import { ICONS } from './index';
import type { IconName } from './index';

export type { IconName };

export const ICON_SIZES = [
  'xs',
  's',
  'default',
  'l',
  'big',
  'big-2',
  'xl',
  'xxl',
  'auto',
] as const;

export const ICON_COLORS = [
  'default',
  'primary',
  'secondary',
  'white',
  'black',
  'success',
  'red',
  'yellow',
  'grey-01',
  'grey-02',
  'grey-03',
  'grey-04',
  'blue-400',
  'blue-500',
  'inherit',
] as const;

export type IconSize = (typeof ICON_SIZES)[number];
export type IconColor = (typeof ICON_COLORS)[number];

export function isIconName(value: unknown): value is IconName {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(ICONS, value);
}
